import {Condition} from "../engine/Condition";
import {isMobileDevice} from "../../../../stem-core/base/Device";
import {toArray} from "../../../../stem-core/base/Utils.js";

const Device = {
    MOBILE: "mobile",
    DESKTOP: "desktop",
};

function getDeviceType() {
    // TODO: Add support for TABLET detection, separate from MOBILE.
    if (isMobileDevice()) {
        return Device.MOBILE;
    }
    return Device.DESKTOP;
}

export interface UserAgentOptions {
    device?: string | string[];
}

export class UserAgentCondition extends Condition<UserAgentOptions> {
    evaluate() {
        let result = true;
        if (this.options.device) {
            result &&= toArray(this.options.device).indexOf(getDeviceType()) !== -1;
        }
        return result;
    }
}
